// extracted by css-extract-rspack-plugin
export default {"DefaultValueFormControl":"default-value-settings-module__DefaultValueFormControl___5ojb"};